import React from "react";
import { Box, Typography } from "@mui/material";
import { OcCurrency } from "oc/components";

interface MyCafeteriaCurrentItemIndicatorProps {
  label: string;
  value: number;
  color: string;
  width: string | number;
}

export const MyCafeteriaCurrentItemIndicator: React.FC<
  MyCafeteriaCurrentItemIndicatorProps
> = ({ label, value, color, width }) => {
  return (
    <Box
      height="96px"
      width={width}
      style={{ backgroundColor: color, borderRadius: "8px" }}
    >
      <Box padding="12px 16px 16px 16px">
        <Typography
          variant="body1"
          style={{
            color: "white",
            padding: "0px",
            margin: "0px",
          }}
        >
          {label}
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Typography
            variant="h4"
            style={{
              color: "white",
              lineHeight: "42.5px",
              padding: "0px",
              margin: "0px",
            }}
          >
            {OcCurrency({ value })}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MyCafeteriaCurrentItemIndicator;
